import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Container } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import styles from './View.Style';

import Loading from 'components_newui/Loading';

import TemplateHeader from './components/TemplateHeader';
import TemplateCard from './components/TemplateCard';
import EmptyState from './components/EmptyState';

const IdeaListTemplates = ({
  classes,
  myEmail,
  getCloneIdeaTemplateFn,
  getIdeaTemplatelistFn,
  listIdeaTemplateLoading,
  listIdeaTemplate = [],
}) => {

  const [searchTerm, setSearchTerm] =useState('');

  useEffect(() => {
    getIdeaTemplatelistFn();
  }, [getIdeaTemplatelistFn]);


  const filteredTemplates = useMemo(() => {
    
    const value = searchTerm.toLowerCase();

    return listIdeaTemplate.filter(item => {
      const title =
        item?.templateName?.toLowerCase() || '';

      const owner =
        item?.createdBy?.toLowerCase() || '';

      return (
        title.includes(value) ||
        owner.includes(value)
      );
    });
  }, [listIdeaTemplate, searchTerm]);


  if (listIdeaTemplateLoading) {
    return <Loading />;
  }

  return (
    <Container maxWidth={false}>
      <div className={classes.scorecardwrp}>
        <TemplateHeader
          classes={classes}
          totalCount={listIdeaTemplate.length}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
        />

        <div className={classes.templateCols}>
          {filteredTemplates.length ? (
            filteredTemplates.map(item => (
              <TemplateCard
                key={item.id}
                classes={classes}
                templateItemData={item}
                myEmail={myEmail}
                getCloneIdeaTemplateFn={
                  getCloneIdeaTemplateFn
                }
              />
            ))
          ) : (
            <EmptyState classes={classes} />
          )}
        </div>
      </div>
    </Container>
  );
};

export default withStyles(styles)(
  IdeaListTemplates
);